enum TypeNotification {
    Info = 0,
    Success = 1,
    Warn = 2,
    Error = 3,
}

export default TypeNotification;
